import _ from 'lodash';
import moment from 'moment';
import store from 'state/store/configureStore';
import { createSelector } from 'reselect';
import { compute5IterationsData } from 'views/root/views/home/views/dashboard/dashboard.service';
import { metricNames } from '@linearb/linjs-common';
import {
  getUiState,
  fill5IterationsIfNeeded,
  isSelectedIterationByDates
} from './helpers';
import { current5IterationsSelector } from './iterations-picker';
import { isIterationsPeriodKeySelectedSelector } from 'state/selectors/ui-state';

const getCommitStats = state => state.commitStats;

const getCommitStatsCount = (
  commitStats = [],
  start_date,
  end_date,
  getterFn
) => {
  const aggregatedCommitStatsRecord = commitStats.find(
    ({ before, after }) => before === end_date && after === start_date
  );

  if (!aggregatedCommitStatsRecord) {
    return null;
  }

  return getterFn(aggregatedCommitStatsRecord);
};

const getCommitActivityTotalValue = ({ sum_stats }) =>
  _.get(sum_stats, metricNames.TOTAL_ACTIVITY, 0);
const getContributorsTotalValue = commitStat =>
  _.get(commitStat, 'contributors', 0);

const create5IterationData = (
  commitStats,
  current5Iterations,
  uiState,
  getterFn,
  name
) => {
  const isIterationsPeriodKeySelected = isIterationsPeriodKeySelectedSelector(
    store.getState()
  );

  const iterations = _(fill5IterationsIfNeeded(current5Iterations))
    .map(({ start_date, end_date, name }, index) => {
      // if selected period - return first iteration; else - return iteration matching start and end date
      const isSelected = isIterationsPeriodKeySelected
        ? isSelectedIterationByDates({
            uiStateDates: uiState?.dates,
            iterationStartDate: start_date,
            iterationEndDate: end_date
          })
        : index === 0;
      const value = getCommitStatsCount(
        commitStats,
        start_date,
        end_date,
        getterFn
      );
      return {
        isSelected,
        start: start_date,
        end: end_date,
        value,
        name
      };
    })
    .orderBy('end')
    .value();

  return compute5IterationsData(iterations, name);
};

export const contributorsBarsSelector = createSelector(
  [getCommitStats, getUiState, current5IterationsSelector],
  (commitStats = [], uiState, current5Iterations) => {
    if (!commitStats.length) {
      return [];
    }

    return create5IterationData(
      commitStats,
      current5Iterations,
      uiState,
      getContributorsTotalValue,
      'CONTRIBUTORS'
    );
  }
);

export const codeChangesGroupedByDaySelector = createSelector(
  [getCommitStats, getUiState],
  (commitStats, uiState) => {
    const {
      dates: { from, to }
    } = uiState;
    if (!commitStats || !commitStats.length) {
      return null;
    }
    return {
      definition: {
        display_name: 'Code Changes'
      },
      graphData: _(commitStats)
        .filter(
          ({ before, after }) =>
            before === after &&
            moment(before).endOf('day').isBetween(from, to, 'day', '[]')
        )
        .map(commitStat => {
          return {
            target_date: commitStat.before,
            items: null,
            total: getCommitActivityTotalValue(commitStat)
          };
        })
        .value()
    };
  }
);
